// src/App.js
import './App.css';
import './output.css';
import Dashboard from './views/Landing/AIDashboard.jsx';
import HomeView from './views/Home/HomeView.jsx';
import Login from './views/Login/Login.jsx';
import Signup from './views/Signup/Signup.jsx';
import ForgotPassword from './views/ForgotPassword/ForgotPassword.jsx';
import NotFound from './views/NotFound/NotFound.jsx';
import WhatsAppOAuthCallback from './components/Integrations/WhatsAppOAuthCallback.jsx';
import ShopifyOAuthCallback from './components/Integrations/ShopifyOAuthCallback.jsx';
import { AuthProvider } from './AuthContext.jsx';
import { AssistantProvider } from './contexts/AssistantContext.jsx';
import { OrganizationProvider } from './contexts/OrganizationContext.jsx';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import client from './apollo-client';
import './i18n/i18n';
import Footer from './components/Footer/Footer.jsx';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.jsx';
import CookieBanner from './components/CookiePolicyBanner/CookiePolicyBanner.jsx';
import Profile from './views/Profile/Profile.jsx';
import { useAuth } from './useAuth';
import { WorkflowBuilderView } from './views/WorkflowEditor/index.js';
import OrganizationsView from './views/Organizations/OrganizationsView.jsx';
import RequireAuth from './components/RequireAuth/RequireAuth.jsx';

function AppContent() {
  const { isAuthenticated, sessionId } = useAuth();

  return (
    <>
      <ScrollToTop />
      <CookieBanner />

      <Routes>
        {/* Rutas públicas */}
        <Route path="/Login" element={<Login />} />
        <Route path="/Signup" element={<Signup />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        
        {/* Callback de WhatsApp OAuth */}
        <Route path="/integrations/whatsapp/callback" element={<WhatsAppOAuthCallback />} />
        
        {/* Callback de Shopify OAuth */}
        <Route path="/shopify/callback" element={<ShopifyOAuthCallback />} />

        {/* Rutas protegidas */}
        <Route element={<RequireAuth />}>
          <Route path="/" element={<HomeView />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/workflow-editor" element={<WorkflowBuilderView />} />
          <Route path="/workflow/builder" element={<WorkflowBuilderView />} />
          <Route path="/WorkflowEditor" element={<WorkflowBuilderView />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/organizations" element={<OrganizationsView />} />
        </Route>

       
        <Route
          path="*"
          element={
            isAuthenticated
              ? <NotFound />
              : <Navigate to="/Login" replace />
          }
        />
      </Routes>

      <Footer />

    
    </>
  );
}

export default function App() {
  return (
    <Router>
      <ApolloProvider client={client}>
        <AuthProvider>
          <OrganizationProvider>
            <AssistantProvider>
              <AppContent />
            </AssistantProvider>
          </OrganizationProvider>
        </AuthProvider>
      </ApolloProvider>
    </Router>
  );
}
